import React from "react";
import { connect } from "react-redux";
import { actionReactivateSubscription } from "../store/actions/subscriptionAction";

const ReactivateSubscriptionModal = ({
    show,
    onHide,
    subscription,
    actionReactivateSubscription,
    subscriptionReactivateLoader
}) => {
    const subscriptionId = subscription?.id || subscription?.stripe_subscription_id;

    const handleReactivate = async () => {
        if (!subscriptionId) {
            alert("Error: Subscription ID not found. Please contact support.");
            return;
        }

        try {
            await actionReactivateSubscription(subscriptionId);
            onHide();
            // Refresh user data
            window.location.reload();
        } catch (error) {
            // Error already handled in action
            console.error("Reactivate subscription error:", error);
        }
    };

    if (!show) return null;

    return (
        <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            <i className="fas fa-undo-alt text-success me-2"></i>
                            Reactivate Subscription
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onHide}
                            disabled={subscriptionReactivateLoader}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-info d-flex align-items-start" role="alert">
                            <i className="fas fa-info-circle me-2 mt-1"></i>
                            <div>
                                <strong>Good news!</strong> You can reactivate your subscription and continue enjoying all features.
                            </div>
                        </div>

                        {subscription && (
                            <div className="mb-4">
                                <h6 className="fw-bold mb-3">Subscription Details:</h6>
                                <div className="row text-sm">
                                    <div className="col-sm-4 text-muted">Plan:</div>
                                    <div className="col-sm-8">{subscription.plan?.name || "Previous Plan"}</div>
                                </div>
                                <div className="row text-sm">
                                    <div className="col-sm-4 text-muted">Status:</div>
                                    <div className="col-sm-8">
                                        <span className="text-warning text-uppercase fw-semibold">
                                            {subscription.status}
                                        </span>
                                    </div>
                                </div>
                                {subscription.current_period_end && (
                                    <div className="row text-sm">
                                        <div className="col-sm-4 text-muted">Period ends:</div>
                                        <div className="col-sm-8">
                                            {new Date(subscription.current_period_end).toLocaleDateString()}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="mb-4 p-3 bg-light rounded">
                            <h6 className="fw-bold mb-2">What happens when you reactivate?</h6>
                            <ul className="mb-0 small">
                                <li>Your subscription will be immediately reactivated</li>
                                <li>You'll regain access to all premium features</li>
                                <li>Billing will resume on your next scheduled billing date</li>
                                <li>No additional charges will apply for reactivation</li>
                            </ul>
                        </div>

                        {!subscriptionId && (
                            <div className="alert alert-danger" role="alert">
                                <i className="fas fa-exclamation-circle me-2"></i>
                                <strong>Error:</strong> Unable to find subscription ID. Please contact support for assistance.
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onHide}
                            disabled={subscriptionReactivateLoader}
                        >
                            Keep Canceled
                        </button>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleReactivate}
                            disabled={subscriptionReactivateLoader || !subscriptionId}
                        >
                            {subscriptionReactivateLoader ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                    Reactivating...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-undo-alt me-2"></i>
                                    Reactivate Subscription
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    subscriptionReactivateLoader: state.subscription?.subscriptionReactivateLoader || false,
});

export default connect(mapStateToProps, { actionReactivateSubscription })(ReactivateSubscriptionModal);
